var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 2.66602C3.42808 2.66602 1.25722 6.58511 0.730551 7.70378C0.642551 7.89044 0.642551 8.10695 0.730551 8.29362C1.25722 9.41295 3.42808 13.3327 8.00008 13.3327C12.5561 13.3327 14.7284 9.44131 15.2644 8.30664C15.3564 8.11131 15.3564 7.88739 15.2644 7.69206C14.7284 6.55739 12.5561 2.66602 8.00008 2.66602ZM8.00008 4.66602C9.84075 4.66602 11.3334 6.15868 11.3334 7.99935C11.3334 9.84001 9.84075 11.3327 8.00008 11.3327C6.15942 11.3327 4.66675 9.84001 4.66675 7.99935C4.66675 6.15868 6.15942 4.66602 8.00008 4.66602ZM8.00008 5.99935C7.46965 5.99935 6.96094 6.21006 6.58587 6.58513C6.2108 6.96021 6.00008 7.46892 6.00008 7.99935C6.00008 8.52978 6.2108 9.03849 6.58587 9.41356C6.96094 9.78864 7.46965 9.99935 8.00008 9.99935C8.53052 9.99935 9.03922 9.78864 9.4143 9.41356C9.78937 9.03849 10.0001 8.52978 10.0001 7.99935C10.0001 7.46892 9.78937 6.96021 9.4143 6.58513C9.03922 6.21006 8.53052 5.99935 8.00008 5.99935Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/Visible.100f667f421018ab132705ab7dd10784.svg";
export { ForwardRef as ReactComponent };